import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import MainCard from 'ui-component/cards/MainCard';
import { post, put, get } from '../../axios/apiService';
import toast from 'react-hot-toast';
import DocumentUploader from 'ui-component/uploadDocument';
import uploadFilesService from '../../axios/uploadFilesService';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getFileNameFromUrl } from 'utils/urlToGetFileName';
import { addPercentage, isEmpty, isValidDate, validateAmount, validateMaxLength } from 'utils/validator';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumberFromString from 'libphonenumber-js';
import { Stack, styled } from '@mui/system';
import NomineeDetails from 'ui-component/nomineeDetail';
import { generateUniqueId } from 'utils/commonfunction';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';

const ResizableTextField = styled(TextField)({
  '& .MuiInputBase-inputMultiline': {
    resize: 'both',
    overflow: 'auto',
  },
});

function AddEditRecurringForm({ id, setIsShowForm, customerId }) {
  const [typeValues, setTypeValues] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [existingDoc, setExistingDoc] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isValidation, setIsValidation] = useState(false);
  const [usedRecurringNominees, setUsedRecurringNominees] = useState([]);
  const [isValidationNominee, setIsValidationNominee] = useState(false);
  const { control, handleSubmit, setValue, getValues,watch } = useForm({
    defaultValues: {
      PlanType: 0,
      Plan: '',
      PolicyNumber: '',
      Company: '',
      Status: '',
      CommencementDate: '',
      MaturityDate: '',
      PolicyTermInYears: 0,
      PremiumAmount: 0,
      PremiumPayingTermInYears: 0,
      InsuredAmount: 0,
      BonusReturns: 0,
      InterestRate: 0,
      RecurringDocuments: null
    }
  });

  const watchedFields = [
    'PlanType',
    'Plan',
    'PolicyNumber',
    'Company',
    'Status',
    'CommencementDate',
    'MaturityDate',
    'PolicyTermInYears',
    'PremiumAmount',
    'PremiumPayingTermInYears',
    'InsuredAmount',
    'BonusReturns',
    'InterestRate'
  ];
  const formValues = useMemo(() =>
    watchedFields.reduce((acc, field) => {
      acc[field] = watch(field);
      return acc;
    }, {}),
    watchedFields.map(watch) 
  );

  useEffect(() => {
    if (isValidation) {
      validator(formValues);
    }
  }, [formValues, isValidation]);

  const {
    control: nomineesControl,
    getValues: nomineesGetValues,
    reset: nomineesReset,
    watch: nomineesWatch
  } = useForm({
    defaultValues: {
      address: "",
      firstName: "",
      lastName: "",
      phone: "",
    },
  });
  // useEffect(() => {
  //   if (isValidation) {
  //     validator(formValues);
  //   }
  // }, [formValues, isValidation]);

  useEffect(() => {
    if (isValidationNominee) {
      const formNomineesData = {
        firstName: nomineesWatch("firstName"),
        lastName: nomineesWatch("lastName"),
        address: nomineesWatch("address"),
        phone: nomineesWatch("phone"),
        allocationPercentage: nomineesWatch("allocationPercentage"),
      };
      validateNominees(formNomineesData);
    }
  }, [isValidationNominee, nomineesWatch("firstName"), nomineesWatch("lastName"), nomineesWatch("address"), nomineesWatch("phone"), nomineesWatch("allocationPercentage")]);


  const onSubmit = async (data) => {
    setIsValidation(true);
    if (!validator()) return;
    let uploadFileList = await uploadDocBlob();
    let recurringDocuments =
      uploadFileList?.map((x) => ({
        blobUrl: x.fileName,
        fileName: documentList[x.fileId - 1].name
      })) || [];
    // if (!id && recurringDocuments.length === 0) {
    //   toast.error('please upload document');
    //   return;
    // }

    if (!customerId) {
      toast.error('Please select customer');
      return;
    }

    if (usedRecurringNominees.length == 0) {
      toast.error("Please add at least one nominee");
 
      return;
    }
    let allocationTotal = 0;
    usedRecurringNominees.forEach((x) => (allocationTotal += parseFloat(x.allocationPercentage.toString())));
    if (allocationTotal != 100) {
      toast.error("Allocation of all nominee(s) must be 100%");
      return;
    }

    (data.CustomerId = customerId), (data.RecurringDocuments = recurringDocuments);


    let param = { ...data };
    param.recurringNominees = usedRecurringNominees;

    if (id) {
      param.id = id;
      let existingFileName = existingDoc?.map((x) => {
        let urlName = getFileNameFromUrl(x.blobUrl);
        return { ...x, blobUrl: urlName };
      });
      param.RecurringDocuments = [...recurringDocuments, ...existingFileName];
      // if (param?.RecurringDocuments?.length === 0) {
      //   toast.error('please upload document');
      //   return;
      // }
    }
    setIsLoading(true);

    let response = id ? await put(`Recurring/${id}`, param) : await post(`Recurring`, param);
    if (response) {
      toast.success(id ? 'Recurring updated successfully' : 'Recurring added successfully');
    }
    setIsLoading(false);
    setIsValidation(false);
    setIsShowForm(false);
  };

  const handleCancel = () => {
    setIsShowForm(false);
  };

  useEffect(() => {
    
    const fetchRecurringById = async (editId) => {
      try {
        setIsLoading(true);
        let response = await get(`Recurring/${editId}`);
        if (response) {
          setValue('BonusReturns', response?.bonusReturns);
          setValue('CommencementDate', response?.commencementDate ? new Date(response?.commencementDate).toLocaleDateString('en-CA') : '');
          setValue('Company', response?.company);
          setValue('InsuredAmount', response?.insuredAmount);
          setValue('InterestRate', response?.interestRate);
          setValue('MaturityDate', response?.maturityDate ? new Date(response?.maturityDate).toLocaleDateString('en-CA') : '');
          setValue('Plan', response?.plan);
          setValue('PlanType', response?.planType);
          setValue('PolicyNumber', response?.policyNumber);
          setValue('PolicyTermInYears', response?.policyTermInYears);
          setValue('PremiumAmount', response?.premiumAmount);
          setValue('PremiumPayingTermInYears', response?.premiumPayingTermInYears);
          setValue('Status', response?.status);
          setValue('RecurringDocuments', response?.recurringDocuments);
          setExistingDoc(response?.recurringDocuments);
          setUsedRecurringNominees(response.recurringNominees);
        }
        setIsLoading(false);
      } catch (error) {
        console.log(error.message);
        setIsLoading(false)
      }
      setIsLoading(false);
    };

    const fetchTypes = async () => {
      try {
        let response = await get(`WillTypeMaster/Recurring`);
        setTypeValues(response);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchTypes();
    if (id) {
      fetchRecurringById(id);
    }
  }, [id]);

  const uploadDocBlob = async (data) => {
    const formData = new FormData();
    for (let i = 0; i < documentList.length; i++) {
      formData.append('files', documentList[i]);
      formData.append('fileIds', i + 1);
    }
    formData.append('categoryId', 5);
    try {
      let data = await uploadFilesService(formData);
      return data;
    } catch (error) {
      console.error('There was an error uploading the files!', error);
    }
  };

  const handleUpload = (newFiles) => {
    setDocumentList((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleRemove = (index) => {
    setDocumentList((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };
  const handleRemoveExistDoc = (index) => {
    setExistingDoc((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };

  const validator = () => {
    let data = getValues();
    const errors = {};
    if (data.category <= 0) {
      errors.category = 'Please Select Category';
    }
    if (isEmpty(data?.Plan)) {
      errors.plan = 'Please Enter Plan';
    }
    if (isEmpty(data?.PolicyNumber)) {
      errors.policyNumber = 'Please Enter PolicyNumber';
    }
    if (!validateMaxLength(data?.PolicyNumber, 20)) {
      errors.policyNumber = ` The value exceeds the maximum allowed length of ${20} characters.`;
    }
    if (isEmpty(data?.Company)) {
      errors.company = 'Please Enter Company';
    }

    if (!validateAmount(data.PolicyTermInYears, 1)) {
      errors.policyTermInYears = "Please enter a valid PolicyTermInYears greater than or equal to 1.";
    }
    if (!validateAmount(data.PremiumAmount, 1)) {
      errors.premiumAmount = "Please enter a valid PremiumAmount greater than or equal to 1.";
    }
    if (!validateAmount(data.PremiumPayingTermInYears, 1)) {
      errors.premiumPayingTermInYears = "Please enter a valid PremiumPayingTermInYears greater than or equal to 1.";
    }
    if (!validateAmount(data.InsuredAmount, 1)) {
      errors.insuredAmount = "Please enter a valid InsuredAmount greater than or equal to 1.";
    }
    if (!validateAmount(data.BonusReturns, 1)) {
      errors.bonusReturns = "Please enter a valid BonusReturns greater than or equal to 1.";
    }
    if (!validateAmount(data.InterestRate, 1)) {
      errors.interestRate = "Please enter a valid InterestRate greater than or equal to 1.";
    }

    if (!isValidDate(data?.MaturityDate)) {
      errors.maturityDate = 'Please Enter MaturityDate';
    }
    if (!isValidDate(data?.CommencementDate)) {
      errors.commencementDate = 'Please Enter CommencementDate';
    }
    if (!validateAmount(data?.PlanType, 1)) {
      errors.planType = "Please select PlanType";
    }
    if (!validateAmount(data?.Status, 1)) {
      errors.status = "Please select Status";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateNominees = (nomineesData) => {
    const errors = {};

    if (isEmpty(nomineesData?.firstName)) {
      errors.firstName = "Please Enter First Name";
    }

    if (isEmpty(nomineesData?.lastName)) {
      errors.lastName = "Please Enter Last Name";
    }

    let mobileNumber = nomineesData?.phone && nomineesData?.phone.startsWith('+') ? nomineesData?.phone : `+${nomineesData?.phone}`;
    let phoneNumber = parsePhoneNumberFromString(mobileNumber);

    if (!phoneNumber || !phoneNumber.isValid()) {
      errors.phone = "Invalid Phone Number";
    }

    if (isEmpty(nomineesData?.address)) {
      errors.address = "Please Enter Address";
    }

    if (!validateAmount(nomineesData?.allocationPercentage, 1)) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage greater than or equal to 1.";
    }
    if (!isNaN(nomineesData?.allocationPercentage) && nomineesData?.allocationPercentage > 100) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    }
    if (!isNaN(nomineesData?.allocationPercentage) && !addPercentage(nomineesData?.allocationPercentage, usedRecurringNominees)) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const saveNominees = () => {
    let nomineesData = {
      firstName: nomineesGetValues("firstName"),
      lastName: nomineesGetValues("lastName"),
      address: nomineesGetValues("address"),
      phone: nomineesGetValues("phone"),
      id: generateUniqueId(),
      allocationPercentage: nomineesGetValues("allocationPercentage"),
    };
    setIsValidationNominee(true);
    if (!validateNominees(nomineesData)) return;
    setIsValidationNominee(false);

    try {
      setIsLoading(true);
      let newNominees = usedRecurringNominees;
      newNominees = [...newNominees, ...[nomineesData]];
      setUsedRecurringNominees(newNominees);
      nomineesReset({
        address: "",
        firstName: "",
        id: "",
        lastName: "",
        phone: "",
        allocationPercentage: 0,
      });
    } catch (error) {
      console.log("error....", error)
    } finally {
      setIsLoading(false);
    }
  };
  const columns = [
    { field: "firstName", headerName: "First Name", flex: 1 },
    { field: "lastName", headerName: "Last Name", flex: 1 },
    { field: "phone", headerName: "Phone Number", flex: 1 },
    { field: "address", headerName: "Address", flex: 1 },
    { field: "allocationPercentage", headerName: "Allocation Percentage", flex: 1 },
    {
      field: "action",
      headerName: "Actions",
      renderCell: (params) => <ActionButtons {...params.row} />,
      // align: 'right',
      width: 200,
      sortable: false,
      filterable: false,
    },
  ];

  const ActionButtons = (row) => {
    return (
      <Stack
        direction={"row"}
        spacing={1}
        justifyContent="center"
        sx={{ marginTop: "10px" }}
      >
        <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={() => {
            handleNomineeEdit(row.id);
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => {
            setUsedRecurringNominees((prevItems) => prevItems.filter((item) => item.id != row.id));
          }}
        >
          Delete
        </Button>
      </Stack>
    );
  };
  const handleNomineeEdit = (nomineeId) => {
    let existingNominee = usedRecurringNominees.filter((x) => x.id == nomineeId);
    const updatedNominees = usedRecurringNominees.filter((nominee) => nominee.id !== nomineeId);
    setUsedRecurringNominees(updatedNominees);
    if (existingNominee && existingNominee[0]) {
      nomineesReset({
        address: existingNominee[0].address,
        allocationPercentage: existingNominee[0].allocationPercentage,
        firstName: existingNominee[0].firstName,
        lastName: existingNominee[0].lastName,
        phone: existingNominee[0].phone,
        id: existingNominee[0].id,
      });
    }
  };

  return (
    <>
      <Box sx={{ padding: '30px 0' }}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={() => setIsShowForm(false)} startIcon={<ArrowBackIcon />}>
              Back
            </Button>
          </Box>
        </Grid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset style={styles.fieldset}>
            <legend style={styles.legend}>Recurring Information</legend>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Plan Type</InputLabel>
                  <Controller
                    name="PlanType"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select labelId="type-label" label="Plan Type" {...field}>
                          {typeValues &&
                            typeValues.map((x, i) => (
                              <MenuItem value={x.id} key={i}>
                                {x.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </>
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.planType}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="Plan" control={control} render={({ field }) => <TextField {...field} label="Plan" />} />
                  <div style={{ color: 'red' }}>{formErrors.plan}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="PolicyNumber"
                    control={control}
                    render={({ field }) => <TextField {...field} label="Policy Number" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.policyNumber}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="Company" control={control} render={({ field }) => <TextField {...field} label="Company" />} />
                  <div style={{ color: 'red' }}>{formErrors.company}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Status</InputLabel>
                  <Controller
                    name="Status"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select labelId="type-label" label="Status" {...field}>
                          <MenuItem value={1}>Active</MenuItem>
                          <MenuItem value={2}>Inactive</MenuItem>
                        </Select>
                      </>
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.status}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="CommencementDate"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="maturity-date"
                        InputLabelProps={{
                          shrink: true // This will keep the label "sticky"
                        }}
                        fullWidth
                        {...field}
                        type="date"
                        label="Commencement Date"
                      />
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.commencementDate}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="MaturityDate"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="maturity-date"
                        InputLabelProps={{
                          shrink: true // This will keep the label "sticky"
                        }}
                        fullWidth
                        {...field}
                        type="date"
                        label="Maturity Date"
                      />
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.maturityDate}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="PolicyTermInYears"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Policy Term In Years" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.policyTermInYears}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="PremiumAmount"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Premium Amount" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.premiumAmount}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="PremiumPayingTermInYears"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Premium Paying Term In Years" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.premiumPayingTermInYears}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="InsuredAmount"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Insured Amount" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.insuredAmount}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="BonusReturns"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Bonus Returns" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.bonusReturns}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="InterestRate"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Interest Rate" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.interestRate}</div>

                </FormControl>
              </Grid>
            </Grid>
          </fieldset>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Document Information</legend>
            <DocumentUploader
              onUpload={handleUpload}
              documentList={documentList}
              onRemove={handleRemove}
              onRemoveExistDoc={handleRemoveExistDoc}
              existDocumentList={existingDoc}
            />
          </fieldset>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Nominee Information</legend>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="firstName" control={nomineesControl} render={({ field }) => <TextField {...field} label="First Name" />} />
                  <div style={{ color: 'red' }}>{formErrors.firstName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="lastName" control={nomineesControl} render={({ field }) => <TextField {...field} label="Last Name" />} />
                  <div style={{ color: 'red' }}>{formErrors.lastName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="phone" control={nomineesControl} render={({ field }) =>
                    <PhoneInput
                      {...field}
                      country={'in'}
                      onChange={(value) => field.onChange(value)}
                      inputStyle={{ width: '100%' }}
                    />

                  } />

                  <div style={{ color: 'red' }}>{formErrors.phone}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="address" control={nomineesControl} render={({ field }) =>
                    <ResizableTextField
                      {...field}
                      label="Address"
                      multiline
                      rows={4} // Specifies initial number of rows
                    />
                  } />
                  <div style={{ color: 'red' }}>{formErrors.address}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                <Controller
                    name="allocationPercentage"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="AllocationPercentage" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.allocationPercentage}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button" 
                    variant="contained"
                    color="primary"
                    style={{ marginRight: "10px" }}
                    onClick={saveNominees}
                  >
                    Save Nominee
                  </Button>
                </Box>
              </Grid>
              {usedRecurringNominees && usedRecurringNominees.length > 0 && (
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
                  <NomineeDetails nominees={usedRecurringNominees} columns={columns} />
                </Grid>
              )}
            </Grid>
          </fieldset>
          <Grid spacing={2} sx={{ marginTop: 3 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button type="submit" variant="contained" color="primary" className="mt-4" style={{ marginRight: '15px' }}>
                Submit
              </Button>
              <Button type="button" variant="contained" color="error" className="mt-4" onClick={handleCancel}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </form>
        <LoadingBackdrop open={isLoading} />
      </Box>
    </>
  );
}

export default AddEditRecurringForm;
const styles = {
  fieldset: {
    border: '1px solid #364152',
    borderRadius: '8px',
    padding: '20px'
  },
  legend: {
    color: '#364152',
    padding: '0 10px',
    fontSize: '18px'
  }
};
